import React, {
  useMemo,
} from "react";
import PropTypes from "prop-types";

import {
  projectGuides,
} from "../../../engines/StudioGuidesEngine";
import {
  useGuides,
  useGuidesRuntime,
} from "./GuidesContext";
import GuideLine from "./GuideLine";


export default function GuidesOverlay({
  viewport = {},
  className = "",
  onGuidePointerDown = null,
}) {
  const collection = useGuides();
  const runtime = useGuidesRuntime();

  const projectedGuides = useMemo(
    () => projectGuides(
      collection,
      viewport,
    ),
    [
      collection,
      viewport,
    ],
  );

  return (
    <div
      className={[
        "studio-guides-overlay",
        className,
      ].filter(Boolean).join(" ")}
      aria-hidden="true"
    >
      {projectedGuides.map((guide) => (
        <GuideLine
          key={guide.id}
          guide={guide}
          onPointerDown={
            onGuidePointerDown
              ? (event) => {
                  onGuidePointerDown(
                    event,
                    guide,
                    runtime,
                  );
                }
              : null
          }
          onDoubleClick={
            guide.locked
              ? null
              : () => runtime.removeGuide(
                  guide.id,
                )
          }
        />
      ))}
    </div>
  );
}


GuidesOverlay.propTypes = {
  viewport: PropTypes.shape({
    offsetLeft: PropTypes.number,
    offsetTop: PropTypes.number,
    scrollX: PropTypes.number,
    scrollY: PropTypes.number,
    zoom: PropTypes.number,
  }),
  className: PropTypes.string,
  onGuidePointerDown: PropTypes.func,
};
